import api from './_api';

const logInApi = (data) => api.post('/account/login/web/', data);
const getUserApi = () => api.get('/account/user/dashboard/');
const searchDeskMembersApi = (s) =>
  api.get(`/search/trading-desk/add-member/?search=${s}`);

export { logInApi, getUserApi, searchDeskMembersApi };
